import { useS3Download } from '@doltech/core/lib/hooks/useS3Download';
import { IconOtherBack15S } from '@doltech/icons/IconOtherBack15S';
import { IconOtherNext15S } from '@doltech/icons/IconOtherNext15S';
import { IconOtherPause } from '@doltech/icons/IconOtherPause';
import { IconOtherPlay } from '@doltech/icons/IconOtherPlay';
import {
  FlatAudioPlayer,
  FlatPlayerInstance,
} from '@doltech/ui/lib/figma/Audio/Player/FlatAudioPlayer';
import { Button } from '@doltech/ui/lib/figma/ButtonV2/ButtonV2';
import { Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { useTestResultStore } from '../../model/test-result.hook';
import { BottomNavigation, BottomNavigationProps } from '../BottomNavigation';
import { QuestionPalletes } from '../QuestionPalletes';
import bookCover from './book-covers/listening-book-cover.png';
import { TestTypeEnum } from '@doltech/utils/lib/constants';

const AudioPlayer = styled.div`
  position: absolute;
  top: -11px;
  left: 0;
  right: 0;
`;

const AudioControls = styled.div`
  display: flex;
  margin-right: 16px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;
interface ListeningBottomNavigationProps extends BottomNavigationProps {}

export const ListeningBottomNavigation = observer((props: ListeningBottomNavigationProps) => {
  const { ...rest } = props;
  const store = useTestResultStore();

  const currentSection = store?.getCurrentTestSection();
  const s3AudioData = useS3Download(currentSection.script?.audio?.path);
  const audioPlayerRef = React.useRef<FlatPlayerInstance>();
  const [playing, setPlaying] = React.useState(false);
  const isFullTest = store.testType === TestTypeEnum.FULL_TEST;

  const renderAudioControls = React.useCallback(() => {
    return (
      <AudioControls className="audio-controls">
        <Button.Icon
          type="secondary"
          onClick={() => {
            if (store.preventUserAction()) return;
            if (audioPlayerRef.current) {
              audioPlayerRef.current.rewind15Second();
            }
          }}
          className="btn-icon"
        >
          <IconOtherBack15S />
        </Button.Icon>
        <Button.Icon
          type="secondary"
          onClick={() => {
            if (store.preventUserAction()) return;
            if (audioPlayerRef.current) {
              audioPlayerRef.current.playPause();
              currentSection.audioManager.play();
            }
          }}
          className="btn-icon"
        >
          {playing ? <IconOtherPause /> : <IconOtherPlay />}
        </Button.Icon>
        <Button.Icon
          type="secondary"
          onClick={() => {
            if (store.preventUserAction()) return;
            if (audioPlayerRef.current) {
              audioPlayerRef.current.forward15Second();
            }
          }}
          className="btn-icon"
        >
          <IconOtherNext15S />
        </Button.Icon>
      </AudioControls>
    );
  }, [currentSection.audioManager, playing, store]);

  return (
    <BottomNavigation defaultBookCover={bookCover} sectionLeft={renderAudioControls()} {...rest}>
      <AudioPlayer className="audio-player-wrapper">
        <Spin size="small" spinning={s3AudioData.isLoading}>
          <FlatAudioPlayer
            ref={audioPlayerRef}
            onPlay={() => {
              setPlaying(true);
            }}
            onPause={() => {
              setPlaying(false);
            }}
            volume={1}
            startTimeInSeconds={currentSection.audioManager.startTimeInSeconds}
            endTimeInSeconds={currentSection.audioManager.endTimeInSeconds}
            onAudioProgress={currentSection.audioManager.progress}
            url={s3AudioData.data?.data?.downloadResourceUrl}
            interactive
          />
        </Spin>
      </AudioPlayer>
      <Wrapper>
        {isFullTest && renderAudioControls()}
        <QuestionPalletes />
      </Wrapper>
    </BottomNavigation>
  );
});
